<template>
    <section id="Profile" class="contain">
        <div class="inner" :style="{ minHeight: screenHeight }">
            <div class="header" id="home">
                <span>My DASHBOARD</span>
            </div>

            <ul class="nav nav-tabs">
                <li role="presentation">
                    <a href="#" @click.prevent="currentPage = 'personal'"
                        >Personal</a
                    >
                </li>
                <li role="presentation" v-if="isPresenter">
                    <a href="#" @click.prevent="currentPage = 'colleagues'"
                        >Colleagues</a
                    >
                </li>
                <li role="presentation" v-if="allowInvestorRegistration">
                    <a href="#" @click.prevent="currentPage = 'availability'"
                        >Availability</a
                    >
                </li>
                <!-- <li role="presentation" v-if="isPresenter">
                    <a href="#" @click.prevent="currentPage = 'schedule-preview'"
                        >Schedule Preview</a
                    >
                </li> -->
                <!-- <li role="presentation" v-if="!isPresenter">
                    <a href="#" @click.prevent="currentPage = 'meeting-preferences'"
                        >Meeting Preferences</a
                    >
                </li> -->
            </ul>

            <div>
                <PersonalDetails
                    v-if="currentPage === 'personal'"
                    :client="profileData.client.client"
                />
                <Colleagues v-if="currentPage === 'colleagues'" />
                <Availability
                    v-if="currentPage === 'availability'"
                    :agendaSlots="profileData.lists.agenda_slots"
                    :availableSlots="available_slots"
                />
                <ProfileSchedule
                    v-if="currentPage === 'schedule-preview'"
                />
                <ProfilePreferences
                    v-if="currentPage === 'meeting-preferences'" 
                />
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
ul {
    margin: 1rem;
}
</style>

<style lang="scss">
.text-center {
    text-align: center;
}
.my-btn {
    margin: 1rem;
    a {
        color: white;
    }
}
</style>

<script>
import PersonalDetails from "./PersonalDetails.vue";
import Availability from "./Availability.vue";
import Colleagues from "./Colleagues.vue";
import ProfileSchedule from "./ProfileSchedule.vue";
import ProfilePreferences from "./ProfilePreferences.vue";
import { mapGetters } from "vuex";

export default {
    components: { PersonalDetails, Availability, Colleagues, ProfileSchedule, ProfilePreferences}, // use 
    data: () => ({
        currentPage: "personal",
        screenHeight: window.innerHeight + "px",
    }),
    computed: {
        ...mapGetters(["profileData"]),
        isPresenter() {
            return this.profileData.client.client.client_type.id === 4;
        },
        available_slots() {
            let client = this.profileData.client;

            if (this.isPresenter)
                return client.presenter_property.available_slot;

            return client.available_slot;
        },
        allowInvestorRegistration() {
            return (
                this.isPresenter ||
                this.profileData.conference.allow_investor_slots_registration
            );
        },
    },
};
</script>
